/*
 * � 2020 Microsoft. All rights reserved.
 */

define('util/SettingsManager',['lodash', 'absolute', 'absolute/storagemanager'],
    function (_, Absolute, StorageManager) {

        return {
            localStorageBaseKey: 'settings',
            defaultSettingsKey: 'settingsDefault',
            settings: {},
            syncData: true,
            load: function () {
                var data = StorageManager.fetch("options")[this.localStorageBaseKey];
                if (typeof data === 'undefined') {
                    data = Absolute.GameConfig.getVal('config')[this.defaultSettingsKey];
                }
                this.settings = data;
                this.syncData = false;
                this.save();
            },
            setSetting: function (gameMode, setting, value) {
                if (!this.settings[gameMode]) {
                    this.settings[gameMode] = {};
                }
                this.settings[gameMode][setting] = value;
                this.syncData = true;
                this.save();
            },
            getSetting: function (gameMode, setting) {
                if (this.syncData) {
                    this.load();
                }
                if (!this.settings[gameMode]) {
                    this.settings[gameMode] = {};
                }
                return this.settings[gameMode][setting];
            },
            reset: function () {
                this.settings = Absolute.GameConfig.getVal(this.defaultSettingsKey);
                this.save();
            },
            save: function () {
                Absolute.GameConfig.setVal(this.localStorageBaseKey, this.settings);
            }
        };

    });

